/**
 * Instagram SNS button — accordion behavior
 */
class SnsButton {
  constructor() {
    this._triggers = Array.from(document.querySelectorAll('.js-sns-accordion-trigger'));
    if (!this._triggers.length) return;
    this._init();
  }

  _init() {
    this._triggers.forEach(trigger => {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      const toggle = () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
        panel.setAttribute('aria-hidden', !isExpanded ? 'false' : 'true');
      };

      trigger.addEventListener('click', toggle);

      // keyboard support
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });

      // open/close on hover (visual via CSS; keep ARIA in sync)
      const wrapper = trigger.closest('.m-sns-button-wrapper');
      // Only attach hover listeners on devices that support hover (desktop)
      if (wrapper && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        wrapper.addEventListener('mouseenter', () => {
          trigger.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        });
        wrapper.addEventListener('mouseleave', () => {
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
        });
      }
    });
  }
}

export default SnsButton;